module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABXSURBVChTY6yvqP/PQARo7GhkYAAp/v/jP0EMVP+fCaIPARg5GFEwMsBQDDQFysIEWE3GBVAUIyvEZgOGySAAU4iugXw3gxQS7WYQwGcyyBjcsiiAgQEA3idBIpD76IEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/SHORTCUT.png
// module id = 97
// module chunks = 0